// initial state
const state = () => ({
  fabrics: [],
  isDecideLater: false,
  activeFabric: undefined,
  defaultFabric: undefined,
  primarySort:'',
  emptyOption: {
    value: "",
    label: "All",
  },
  chooseNowOption: {
    value: "",
    label: "Choose Fabric Now",
  },
  decideLaterOption: {
    label: "Still not sure on color, want to decide later?",
    title: "Decide Later",
    sku_code: "DFL",
    description:
      "Go ahead and place your order today. Then order your <u>free set of swatches</u> rushed to your door.<a href='/pages/swatches'>Learn More</a>",
  },
  chooseText: "Select This Fabric",
  decideLaterText: "Buy Now, Decide Later",
  fabricFilters: [],
  colorConfig: [
    {
      name: "Blues",
      code: "#32667c"
    },
    {
      name: "White-Naturals",
      code: "#E4E2DF"
    },
    {
      name: "Greens",
      code: "#797E43"
    },
    {
      name: "Vibrants",
      code: "#732B1A"
    },
    {
      name: "Greys-Blacks",
      code: "#6D6F6E"
    },
    {
      name: "Browns-Naturals",
      code: "#6E5843"
    },
  ]
    
});

// getters
const getters = {
  getFabrics: (state) => {
    let tempFabrics = state.fabrics
    if (state.primarySort) {
      let key = ''
      switch(state.primarySort) {
        case 'alpha':
          key = 'title'
          break;
        case 'color':
          key = 'colors'
          break;
        case 'collection':
          key = 'fabric_collection'
          break;
        case 'type':
          key = 'fabric_options'
          break;
      }
      if (key) {
        tempFabrics = [...state.fabrics].sort((a, b) => {
          const aVal = Array.isArray(a[key]) ? a[key][0] : a[key]
          const bVal = Array.isArray(b[key]) ? b[key][0] : b[key]
          return aVal < bVal ? -1 : aVal > bVal ? 1 : 0
        });
      }
    }
    return tempFabrics
  },
  isDecideLater: (state) => {
    return state.isDecideLater;
  },
  getActiveFabric: (state) => {
    return state.activeFabric;
  },
  getActiveType: (state) => {
    if (state.activeFabric && state.activeFabric.fabric_options) {
      return state.activeFabric.fabric_options[0];
    }
    return "Decide Later";
  },
  getDefaultFabric: (state) => {
    return state.defaultFabric;
  },
  getEmptyOption: (state) => {
    return state.emptyOption;
  },
  getDecideLaterOption: (state) => {
    return state.decideLaterOption;
  },
  getChooseNowOption: (state) => {
    return state.chooseNowOption;
  },
  getChooseText: (state) => {
    return state.chooseText;
  },
  getDecideLaterText: (state) => {
    return state.decideLaterText;
  },
  getMatchingFabric: (state) => (sku_code) => {
    return state.fabrics.find((fabric) => fabric.sku_code === sku_code);
  },
  queryFabrics: (state) => (queryObject) => {
    const queryCopy = Object.assign({}, queryObject);
    let findMultiple = false;
    if (queryCopy.findMultiple) {
      findMultiple = queryCopy.findMultiple;
      delete queryCopy.findMultiple;
    }
    const findFunction = (fabric) => {
      let isMatch = true;
      Object.keys(queryCopy).forEach((key) => {
        if (
          !fabric[key] ||
          fabric[key].toString() !== queryCopy[key].toString()
        ) {
          isMatch = false;
        }
      });
      return isMatch;
    };
    let fabricsCopy = [...state.fabrics];
    fabricsCopy.push(state.decideLaterOption);
    if (findMultiple) {
      return fabricsCopy.filter(findFunction);
    } else {
      return fabricsCopy.find(findFunction);
    }
  },
  getFilters: (state) => {
    return state.fabricFilters
  },
  getColorConfig: (state) => {
    return state.colorConfig
  },
  getActiveFilters: (state) => {
    return JSON.parse(JSON.stringify(state.fabricFilters)).filter((filter) => {
      return filter.values.filter((value) => value.active ).length
    }).map((filter) => {
      filter.values = filter.values.filter((value) => value.active)
      return filter
    })
  }
};

// actions
const actions = {
  setFabrics({ commit }, fabrics) {
    commit("setFabrics", { fabrics });
  },
  setPrimarySort({ commit }, primarySort) {
    commit("setPrimarySort", { primarySort });
  },
  activateFabric({ commit }, newFabric) {
    commit("setActiveFabric", { newFabric });
  },
  setDecideLater({ commit }, isDecideLater) {
    commit("setDecideLater", { isDecideLater });
  },
  setDefaultFabric({ commit }, defaultFabric) {
    commit("setDefaultFabric", { defaultFabric });
  },
  setFabricFilters({ commit }, fabricFilters) {
    commit("setFabricFilters", { fabricFilters });
  },
  activateFabricFilter({ commit }, {filterToActivate, filterValue, joinActiveFilters = false}) {
    commit("activateFabricFilter", { filterToActivate, filterValue, joinActiveFilters });
  },
  resetFabricFilter({ commit }, {filterToReset}) {
    commit("resetFabricFilter", { filterToReset });
  }
};

// mutations
const mutations = {
  setFabrics(state, { fabrics }) {
    state.fabrics = fabrics;
  },
  setPrimarySort(state, { primarySort }) {
    state.primarySort = primarySort;
  },
  setActiveFabric(state, { newFabric }) {
    state.activeFabric = newFabric;
  },
  setDecideLater(state, { isDecideLater }) {
    state.isDecideLater = isDecideLater;
  },
  setDefaultFabric(state, { defaultFabric }) {
    state.defaultFabric = defaultFabric;
  },
  setFabricFilters(state, { fabricFilters }) {
    state.fabricFilters = fabricFilters;
  },
  activateFabricFilter(state, { filterToActivate, filterValue, joinActiveFilters}) {
    // state.fabricFilters = fabricFilters;
    const filterCopy = [...state.fabricFilters]
    const matchingFilter =  filterCopy.find((filter) => filter.heading == filterToActivate.heading)
    if (matchingFilter) {
      if(!joinActiveFilters) {
        matchingFilter.values.forEach((value) => value.active = false)
      }
      const matchingValue = matchingFilter.values.find((value) => value.value == filterValue.value)
      if (matchingValue) {
        matchingValue.active = !matchingValue.active
      }
      matchingFilter.activeFilters = matchingFilter.values.reduce(function (accumulator, currentVal) {
        const filtersString = currentVal.active ? currentVal.value : ''
        return accumulator + filtersString;
      }, '');
      state.fabricFilters = filterCopy
    }
  },
  resetFabricFilter(state, { filterToReset }) {
    const filterCopy = [...state.fabricFilters]
    const matchingFilter =  filterCopy.find((filter) => filter.heading == filterToReset.heading)
    if (matchingFilter) {
      matchingFilter.values.forEach((value) => value.active = false)
      state.fabricFilters = filterCopy
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
